module.exports = __webpack_public_path__ + "64d28ad81ad87f1c5087645a75358150.png";